export function copyToClipboard(value: any) {
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = value;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
}

export function cloneDeepObj(obj) {
  if (!obj) return null;
  return JSON.parse(JSON.stringify(obj));
}

/** حذف آیتم های تکراری از آرایه  */
export function fixArray(array: any[]): any[] {
  let collection = new Set();
  array.map((item) => {
    collection.add(item);
  });
  return [...collection];
}

export function reverseText(text): string {
  if (text) return text?.split('')?.reverse()?.join('');
  else return text;
}
